import { useMemo } from 'react';
import { ProgressItemType } from '@/types/bodyAndPaint';

interface ProcessImageDataHookProps {
  info: ProgressItemType[];
}
export const useProcessImageData = ({ info }: ProcessImageDataHookProps) => {
  const processImageDataList = useMemo(
    () =>
      info.map((infoItem) => {
        const REPAIR_PROCESS = {
          '1': '取り外し',
          '2': '板金',
          '3': '板金修正',
          '4': '塗装',
          '5': 'パテ埋め作業',
          '6': '作業完了',
        };

        const data = Object.entries(infoItem).reduce(
          (list, item) => {
            const [processStep, detail] = item;
            const processName =
              REPAIR_PROCESS[processStep as keyof typeof REPAIR_PROCESS] ?? '';
            const detailList = Object.keys(detail)
              .sort((a, b) => Number(a) - Number(b))
              .map((key) => {
                const pathItem = detail[key]?.image_lists ?? {};
                return {
                  name: detail[key].work_name,
                  path: Object.values(pathItem) ?? [],
                };
              })
              .filter((item) => item.name && item.path.length > 0);

            if (detailList.length > 0) {
              list.push({ processName, detailList });
            }
            return list;
          },
          [] as {
            processName: string;
            detailList: {
              name: string;
              path: string[];
            }[];
          }[],
        );
        return data;
      }),
    [info],
  );

  return { processImageDataList };
};
